import { AbstractJavascriptFunctionCallFactory } from "./AbstractJavascriptFunctionCallFactory";
import { AbstractJavascriptFunctionCallVO } from "./AbstractJavascriptFunctionCallVO";
import { IEnvironmentGlobals } from "../../../IEnvironmentGlobals";
import { EnvGlobalsHandler } from "../../../EnvGlobalsHandler";
import { JavascriptCallSetLanguageVO } from "./JavascriptCallSetLanguageVO";

export class JavascriptCallSetLanguageFactory implements AbstractJavascriptFunctionCallFactory {

    public createVO(): AbstractJavascriptFunctionCallVO {
        let vo: JavascriptCallSetLanguageVO = new JavascriptCallSetLanguageVO(this.env.currentCountryLanguageCode);
        return vo;
    }

    private get env(): IEnvironmentGlobals {
        return EnvGlobalsHandler.globals;
    }
}
